<template>
  <div class=" is-fullwidth">
   
    <div class="is-pulled-right"><select class="input" v-model="limit" style="display:none">
      <option value="">Number of Orders</option>
      <option value="10">10 orders</option>  
      <option value="50">50 orders</option>  
      <option value="100">100 orders</option>  
      <option value="250">250 orders</option>  
      <option value="">Display All Orders</option>  
    </select></div>
     <div class="is-pulled-right"><input class="input" v-model="search" placeholder="search orders ..."/></div>
     <div class="is-pulled-right" style="display:none"><input class="input" type="date" v-model="start_date" placeholder="Start Date"/></div>
    <div class="buttons">
        
          <button class="button " v-bind:class="{'is-success': selected_location_id == row.id}" v-for="row in locations" :key="row.id" @click="selected_location_id = row.id">{{ row.name }}</button>
        
          <button class="button is-light">{{ filteredOrders.length }} orders</button>
        <button class="button is-light">{{ this.total_garments }} garments</button>
      </div>
   
    
    <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable">
    	<thead>
    		<th width="60">&nbsp;</th>
        <th width="60">&nbsp;</th>
        <th>PO Number</th>
   	 		<th>Customer</th>
          <th @click="updateSortOrder('orderdate')" style="cursor:pointer;">Order Date
            <span v-if="order_by === 'orderdate DESC'">&#8595;</span>
            <span v-if="order_by === 'orderdate ASC'">&#8593;</span>
          </th>
          <th @click="updateSortOrder('deliverydate')" style="cursor:pointer">Delivery
            <span v-if="order_by === 'deliverydate DESC'">&#8595;</span>
            <span v-if="order_by === 'deliverydate ASC'">&#8593;</span>
          </th>
          <th>Garment</th>
          <th>Extras</th>
          <th>Fabric</th>
          <th>Type</th>
          <th>Qty</th>
          <th>Paper</th>
          <th>Rolls</th>
          <th>Cutting</th>
          <th>&nbsp;</th>
          <th >Makeup</th>
    	</thead>
    	<tbody>
		    <tr v-if="loading === true">
                <td colspan="16" ><div class="notification is-info">Loading orders ...</div></td>
            </tr>
            <tr v-if="loading == false && filteredOrders.length == 0">
                <td colspan="16" ><div class="notification is-warning">There are no orders to show</div></td>
            </tr>
            
            <tr v-for="order in filteredOrders" v-bind:key="order.orderID" :class="{'has-background-danger has-text-white' : order.printing_urgent == 1}">
         <td >
                  <a :href="ASP_URL + '/printorder.asp?txtPONumber=' + order.ponumber" target="_blank"><button class="button is-small is-info" :disabled="working===true" >Print</button></a>
              </td>
              <td><button class="button is-small is-danger" @click="markUrgent(order)" v-if="order.printing_urgent == 0" :disabled="working===true">Urgent</button></td>
               <td ><router-link :to="'/printing-cutting/view-order/' + order.ponumber" target="_blank">{{order.ponumber}}</router-link></td>
          <td>{{order.clientname}}</td>
           <td >{{order.orderdate}}</td>
          <td>{{order.deliverydate}}</td>
          <td>{{order.garmentname}}</td>
          <td>
            <div class="tags">
              <button class=" button tag  is-small" v-if="order.requires_embroidery==1" :class="{'is-success' : order.embroidery_complete == 1}" :disabled="working==true">Embroidery</button>
              <button class=" button tag   is-small" v-if="order.requires_embossing==1" :disabled="working==true">Embossing</button>
              <button class=" button tag  is-small" v-if="order.requires_silicon_stripes==1" :disabled="working==true">Silicon </button>
              <button class=" button tag  is-small" v-if="order.requires_dtf==1" :disabled="working==true">DTF </button>
              <button class=" button tag  is-small" v-if="order.requires_gps_pockets==1" :disabled="working==true">GPS </button>

              <button class=" button tag is-small" v-if="order.requires_knitted_trim==1" :class="{'is-success' : order.knitted_trim_complete == 1}" :disabled="working==true" @click="completeKnittedTrims(order)">Knitted Trim</button>
              
            </div>
          </td>
          <td>{{order.fabric_name}}</td>
          <td>
            <span v-if="order.fully_printed==1">F/P</span>
              <span v-if="order.part_printed==1">P/P</span>
                <span v-if="order.cut_sew==1">C/S</span>

          </td>
          <td>{{ order.total_qty }}</td>
          <td>
              <span class="icon has-text-success" v-if="order.artwork_printed_paper == 1">
                <i class="fa fa-check"></i>
            </span>
            <span v-else>
                <span v-if="order.printing_papers_total > 0">
                  {{order.printing_papers_total}}
                </span>
                <span v-else>
                  <span v-if="order.print_location_id==1">IRL</span>
                  <span v-if="order.print_location_id==2">ROM</span>
              </span>
            </span>

           
          </td>
          <td>
            <span class="icon has-text-success" v-if="order.artwork_printed_rolls == 1">
                <i class="fa fa-check"></i>
            </span>
            <span v-else>
                <span v-if="order.fabric_printing_papers_total > 0">
                  {{order.fabric_printing_papers_total}}
                </span>
                <span v-else>
                  <span v-if="order.fabric_print_location_id==1">IRL</span>
                  <span v-if="order.fabric_print_location_id==2">ROM</span>
              </span>
            </span>

          </td>
          <td>
<span class="icon has-text-success" v-if="order.digital_print_cutting == 1">
                <i class="fa fa-check"></i>
            </span>
            <span v-else>
                <span v-if="order.gerber_printing_papers_total > 0">
                  {{order.gerber_printing_papers_total}}
                </span>
                <span v-else>
                  <span v-if="order.gerber_print_location_id==1">IRL</span>
                  <span v-if="order.gerber_print_location_id==2">ROM</span>
              </span>
            </span>

          </td>
          <td>
            <router-link :to="'/printing-cutting/bundling/' + order.orderID" v-if="order.print_location_id != 2">
                <span class="icon" :class="{ 'has-text-success': order.bundles_created == 1, 'has-text-danger': order.bundles_created == 0}">
                 <i class="fa fa-barcode">&nbsp;</i>
               </span>
               </router-link>

          </td>
          <td >{{ order.makeup_location_name}}</td>
			</tr>
    	</tbody>
    </table>

    <table class="table is-hoverable is-fullwidth" id="orderstableexcel" style="display:none">
    	<thead>
        <tr>
    		<th>PO Number</th>
   	 		<th>Customer</th>
          <th  >Order Date
            
          </th>
          <th >Delivery
           
          </th>
          <th>Garment</th>
          <th>Fabric</th>
          <th>Design Name</th>
          <th>Type</th>
          <th>Qty</th>
          <th>Paper</th>
          <th>Rolls</th>
          <th>Cutting</th>
        </tr>
    	</thead>
    	<tbody>
		    
            
            <tr v-for="order in filteredOrders" v-bind:key="'xls' + order.orderID" >
         
               <td >{{order.ponumber}}</td>
          <td>{{order.clientname}}</td>
           <td >{{order.orderdate_raw.slice(0,10)}}</td>
          <td>{{order.deliverydate_raw.slice(0,10)}}</td>
          <td>{{order.garmentname}}</td>
          <td>{{order.fabric_name}}</td>
          <td>{{order.designname}}</td>
          <td>
            <span v-if="order.fully_printed==1">F/P</span>
              <span v-if="order.part_printed==1">P/P</span>
                <span v-if="order.cut_sew==1">C/S</span>

          </td>
          <td>{{ order.total_qty }}</td>
          <td>
              {{order.printing_papers_total}}
          </td>
          <td>
            {{order.printing_rolls_total}}
          </td>
          <td>
            {{ order.cuttings_total }}
          </td>
          
             
			</tr>
    	</tbody>
    </table>
    
    <button @click="exportXLS()" class="button is-info" v-if="loading==false">Export to Excel</button>
    
  </div>
</template>

<script>


import OrderService from '@/services/OrderService.js';
import UtilityService from '@/services/UtilityService.js';
import OrderMixin from "@/mixins/OrderMixin.js";
import XLSX from 'xlsx';

export default {
  components: {
   	
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      locations: [],
      order_by: 'deliverydate ASC',
      search: '',
      selected_location_id:0,
      limit: '',
      accessToken: '',
      start_date: ''
    }
  },
   methods: {
    async markUrgent(order) {
        this.working = true
        
        var order_id = order.orderID

        var formdata = { 
            _method: 'patch',
             printing_urgent: 1
        }; 

        OrderService.updateOrder(this.accessToken, order_id, formdata)
        .then(() => {
            this.working = false
            order.printing_urgent = 1
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },
      async getOrders() {
        if(this.selected_location_id > 0)
        {
          this.loading=true
          OrderService.getPrintingCuttingOrders(this.accessToken, this.selected_location_id, this.limit, this.order_by, this.start_date, '', 1)
          .then(
            (orders => {
              this.$set(this, "orders", orders);
              this.loading=false
            }).bind(this)
          );
        }
        else{
          this.orders = []
          this.loading = false
        }
      },
      async completeKnittedTrims(order) {
          this.working = true

          if(order.knitted_trim_complete == 1)
          {
              this.working = false
              return false
          }
          else
          {
            if(confirm("Are you sure you want to mark this order as Knitted Trims complete ?"))
            {
              var order_id = order.orderID

                var formdata = { 
                    _method: 'patch',
                    knitted_trim_complete : 1
                    
                }; 

                OrderService.updateOrder(this.accessToken, order_id, formdata)
                .then(() => {
                    order.knitted_trim_complete = 1
                    this.working = false
                    //console.log(response)
                }).catch((error) => {
                  alert("Something went wrong and the order has not been updated. Please reload and try again")
                    console.log("Error:" + JSON.stringify(error.response.data));
                    this.working = false
                });
            }
            else{
              this.working = false
              return false
            }
            
          }
        },
    
    async processOrder(order) {
        this.working = true

        var order_id = order.orderID

        var formdata = { 
            _method: 'patch',
             artwork_printed_paper: 1
        }; 

        OrderService.updateOrder(this.accessToken, order_id, formdata)
        .then(() => {
            order.artwork_printed_paper = 1
            this.working = false
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },
    async getLocations() {
        UtilityService.getSimpleApiData(this.accessToken, "locations?printing=1&restrict_by_user=1").then(
               response => this.locations = response 
            );
      },
      exportXLS() {
      
      var wb = XLSX.utils.table_to_book(document.getElementById('orderstableexcel'), {sheet:"Sheet 1"});
      XLSX.writeFile(wb, 'Printing Overview.xlsx')

    },
    
  },
  computed : {
      filteredOrders: function () {
       
        let filteredOrders =  this.orders.filter(function(row) {
            //if(  u.artwork_printed_paper == 0) 
           // {
               console.log(row)
              return 1
           // }
          })

          if(this.search != '' && this.search != null)
          {
            filteredOrders = filteredOrders.filter(row => row.ponumber.toLowerCase().includes(this.search.toLowerCase()))
          }

          return filteredOrders
       
     },
     total_garments: function () {
        return this.filteredOrders.reduce((total, order) => total + order.total_qty, 0);
     }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           this.getPrintLocations();
        });
  },
 
  mounted() {
    if (localStorage.printing_limit) {
      this.limit = localStorage.printing_limit;
    }
    else{
      this.limit = ''
    }

    if (localStorage.printing_location_id) {
      this.selected_location_id = localStorage.printing_location_id;
    }
    else{
      this.selected_location_id = ""
    }

    if (localStorage.printing_start_date) {
      //this.start_date = localStorage.printing_start_date;
    }
    else{
      //this.start_date = ''
    }
      
  },
   watch: {
    'selected_location_id'() {
      this.orders = []
      localStorage.printing_location_id = this.selected_location_id
      this.getOrders();
    },
    'limit'() {
      localStorage.printing_limit = this.limit
      this.orders = []
      this.getOrders();
    },
    'start_date'() {
      localStorage.printing_start_date = this.start_date
      this.orders = []
      this.getOrders();
    }
  }
}


</script>

